const VaLoanList = {
    mililitaryexp: [
        { text: 'Active Service', value: 'Regular' },
        { text: 'Reserves / National Guard', value: 'NotRegular' },
        { text: 'Retired', value: 'NotRegular' },
    ],
    disabilitystatus: [
        { text: 'Not Disabled', value: 'Notdisabled' },
        { text: 'Disabled', value: 'Disabled' },
    ],
    firsttimeva: [
        { text: 'Yes', value: 'First' },
        { text: 'No', value: 'NotFirst' },
    ],
};

const VeteranFeeList = {
    DisabledFirstRegulartier1: 0,
    DisabledFirstRegulartier2: 0,
    DisabledFirstRegulartier3: 0,
    NotdisabledFirstRegulartier1: 2.3,
    NotdisabledFirstRegulartier2: 1.50,
    NotdisabledFirstRegulartier3: 1.25,
    DisabledNotFirstRegulartier1: 0,
    DisabledNotFirstRegulartier2: 0,
    DisabledNotFirstRegulartier3: 0,
    NotdisabledNotFirstRegulartier1: 3.60,
    NotdisabledNotFirstRegulartier2: 1.50,
    NotdisabledNotFirstRegulartier3: 1.25,
    DisabledFirstNotRegulartier1: 0,
    DisabledFirstNotRegulartier2: 0,
    DisabledFirstNotRegulartier3: 0,
    NotdisabledFirstNotRegulartier1: 2.30,
    NotdisabledFirstNotRegulartier2: 1.75,
    NotdisabledFirstNotRegulartier3: 1.50,
    DisabledNotFirstNotRegulartier1: 0,
    DisabledNotFirstNotRegulartier2: 0,
    DisabledNotFirstNotRegulartier3: 0,
    NotdisabledNotFirstNotRegulartier1: 3.60,
    NotdisabledNotFirstNotRegulartier2: 1.75,
    NotdisabledNotFirstNotRegulartier3: 1.50,
};

export default {
    VaLoanList, VeteranFeeList,
};
